import { Col, Row, Card, Form, Button } from 'react-bootstrap';
import { useState } from 'react';
import Address from './Address';
import EditCompanyForm from './EditCompanyForm';
import TitleCard from './TitleCard';

const CompanyInfo = ({
  initialValues = {
    id: 0,
    name: '',
    address: '',
    city: '',
    state: '',
    phone: '',
    zip: '',
    email: '',
  },
  _new = false,
  onSubmit,
  onCancel = () => {},
  onDelete = null,
  index = 0,
  aLabel,
}) => {
  const [editing, setEditing] = useState(_new);
  if (editing)
    return (
      <EditCompanyForm
        initialValues={initialValues}
        onSubmit={onSubmit}
        setEditing={setEditing}
        onCancel={onCancel}
        onDelete={onDelete}
        index={index}
        aLabel={aLabel}
      />
    );
  else
    return (
      <Card className="mb-3 company-card">
        <Card.Header className="d-flex justify-content-between">
          <Row className="w-100">
            <Col xs={10}>
              <Card.Title className="mb-0 fs-3" data-cy="company-name">
                {initialValues.name}
              </Card.Title>
              <Form.Text muted>ID: {initialValues.id}</Form.Text>
            </Col>
            <Col xs={2} className="d-flex justify-content-end px-0">
              <Button
                className="dark-btn"
                aria-label="edit-company-info"
                onClick={() => setEditing(true)}
              >
                Edit
              </Button>
            </Col>
          </Row>
        </Card.Header>
        <Card.Body className="py-0" style={{ paddingRight: '11px', paddingLeft: '11px' }}>
          <Row>
            <Col xs={12} md={4} className="p-0">
              <Address values={initialValues} />
            </Col>
            <Col xs={12} md={4} className="p-0">
              <TitleCard title="Email" cName="email" headerFontSize="1.4rem">
                <a href={`mailto:${initialValues.email}`} data-cy="company-email">
                  {initialValues.email}
                </a>
              </TitleCard>
            </Col>
            <Col xs={12} md={4} className="p-0">
              <TitleCard title="Phone" cName="phone" headerFontSize="1.4rem">
                {initialValues.phone}
              </TitleCard>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    );
};

export default CompanyInfo;
